// extracted by mini-css-extract-plugin
export default {"cubic":"MainLayouts_cubic__fzHz7","mask":"MainLayouts_mask__klslO","onMove":"MainLayouts_onMove__RiduB","on_roate":"MainLayouts_on_roate__U0Imw"};